module.exports = __webpack_public_path__ + "static/media/goal_not_achieved.70109100.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/goal_not_achieved.svg
// module id = 277
// module chunks = 0